import React from "react";
import { FormattedMessage } from "react-intl";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { TVehicle } from "types";

import { vehicle as defaultVehicle } from "fixtures";
import Button from "@mui/material/Button";

import { DefaultFinanceFilter } from "../../Detail";
import Detail from "../Finance/Detail";
import { Tupel } from "components";

interface ISummary {
  paperProps?: any;
  vehicle: TVehicle;
  financeFilter: any;
  financeRate: any;
  action: any;
}

const Summary: React.FC<ISummary> = ({
  paperProps = { sx: { p: 2 } },
  vehicle = defaultVehicle,
  financeFilter = DefaultFinanceFilter,
  financeRate,
  action: actionHandler,
}): JSX.Element => {
  const { modell } = vehicle;
  return (
    <Paper variant="outlined" {...paperProps}>
      <Typography
        variant="h4"
        sx={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          wordWrap: "no-break",
        }}
      >
        {modell.marke.name} {modell.name}
      </Typography>
      <Typography
        gutterBottom
        variant="h6"
        sx={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          wordWrap: "no-break",
        }}
      >
        {vehicle.typtext}
      </Typography>
      <Tupel
        labelId="filter.aufbau.label"
        textId={`aufbau.${vehicle.aufbau.id}.label`}
      />
      <Tupel
        labelId="filter.fzart.label"
        textId={`fzart.${vehicle.fzart.id}.label`}
      />
      <Tupel labelId="common.offerNumber" text={vehicle.id} />
      <Detail {...{ vehicle, financeRate }} short />
      <Box sx={{ mt: 4, textAlign: "center" }}>
        <Button variant="contained" onClick={() => actionHandler()}>
          <FormattedMessage
            id="common.buyCar"
            defaultMessage="Fahrzeug kaufen"
          />
        </Button>
      </Box>
    </Paper>
  );
};

export default Summary;
